import { useMutation } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type RegistPatientBody = Parameters<typeof apiClient.v2.apiRegistPatientElCreate>[0]

const registPatient = async (body: RegistPatientBody) => {
  const { data } = await apiClient.v2.apiRegistPatientElCreate(body)
  return checkApiResponse(data)
}

export const useRegistPatientCreateMutation = ({ options }: MutationComposableParams<unknown, RegistPatientBody> = {}) => {
  return useMutation(() => ({
    mutationFn: registPatient,
    ...resolveMaybeGetter(options ?? {}),
  }))
}
